import { useState } from "react";
import {
  Grid,
  TextField,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Loading,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "../../../../components";
import {
  ContasPagarService,
  notification,
  history,
} from "../../../../services";
import { responseErros } from "../../../../utils";
import contaPagarDesdobrarTituloValidator from "../middlewares/contaPagarDesdobrarTitulo.validator";
import desdobrarTituloValidator from "../middlewares/desdobrarTitulo.validator";

const DesdobrarTitulo = ({
  contaPagar,
  meioPagamento,
  dadosPagamentoList,
  observacaoList,
  inputErros,
  setInputErro,
}) => {
  const [loading, setLoading] = useState(false);
  const [openDesdobrarTitulo, setOpenDesdobrarTitulo] = useState(false);
  const [desdobramentoTitulo, setDesdobramentoTitulo] = useState({
    tipoDesdobramento: "QUANTIDADE",
  });
  const contasPagarService = new ContasPagarService();

  const handleOpenDialog = () => {
    setOpenDesdobrarTitulo(true);
  };

  const handleCloseDialog = () => {
    setOpenDesdobrarTitulo(false);
  };

  const handleChange = (event) => {
    setDesdobramentoTitulo((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const validarContaPagar = () => {
    setInputErro([]);
    contaPagarDesdobrarTituloValidator
      .validate(contaPagar, { abortEarly: false })
      .then(() => {
        validarDesdobramentoTitulo();
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const validarDesdobramentoTitulo = () => {
    setInputErro([]);
    desdobrarTituloValidator
      .validate(desdobramentoTitulo, { abortEarly: false })
      .then(() => {
        desdobrarTitulo();
      })
      .catch((err) => {
        inputErros.set(err);
      });
  };

  const desdobrarTitulo = async () => {
    const body = {
      desdobramentoTitulo,
      contaPagar: {
        ...contaPagar,
        observacaoList,
        bancoCaixaId: meioPagamento?.bancoCaixaId,
        pagamentos: dadosPagamentoList,
      },
    };
    setLoading(true);
    const res = await contasPagarService.desdobrarTitulo(body);
    setLoading(false);
    if (!res.isAxiosError) {
      notification.cadastroSucesso();
      history.goBack();
    } else {
      responseErros(res);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        className="mt-3"
        fullWidth
        color="primary"
        aria-controls={openDesdobrarTitulo ? "split-button-menu" : undefined}
        aria-expanded={openDesdobrarTitulo ? "true" : undefined}
        aria-haspopup="menu"
        onClick={handleOpenDialog}
        sx={{ height: "52px" }}
      >
        Desdobrar título
      </Button>
      <Dialog fullWidth maxWidth={"sm"} open={openDesdobrarTitulo}>
        <CardHeader title="Desdobrar Título" className="m-2" />
        <DialogContent>
          <Grid container spacing={2}>
            <span
              id="tipoDesdobramento"
              style={{
                padding: "0 24px",
                margin: 0,
              }}
            >
              Tipo de desdobramento :
            </span>
            <DialogActions className="d-flex flex-row justify-content-start ms-3">
              <RadioGroup
                aria-labelledby="tipoDesdobramento"
                name="tipoDesdobramento"
                value={desdobramentoTitulo?.tipoDesdobramento ?? ""}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="QUANTIDADE"
                  control={<Radio />}
                  label="Desdobrar criando outras parcelas com mesmo valor"
                />
                <FormControlLabel
                  value="VALOR"
                  control={<Radio />}
                  label="Desdobrar dividindo valor total em parcelas"
                />
              </RadioGroup>
            </DialogActions>
            <Grid
              container
              xs={11}
              className="d-flex"
              style={{ padding: "0 24px" }}
            >
              <Grid item xs={6}>
                <TextField
                  id="qtdParcelas"
                  name="qtdParcelas"
                  label="Quantidade de parcelas"
                  variant="outlined"
                  margin="normal"
                  required
                  type="number"
                  onChange={handleChange}
                  value={desdobramentoTitulo?.qtdParcelas ?? ""}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="intervaloDias"
                  name="intervaloDias"
                  label="Intervalo de dias"
                  variant="outlined"
                  margin="normal"
                  required
                  type="number"
                  style={{ marginLeft: 20 }}
                  onChange={handleChange}
                  value={desdobramentoTitulo?.intervaloDias ?? ""}
                  fullWidth
                />
              </Grid>
            </Grid>
            <DialogActions className="d-flex flex-row justify-content-start m-3">
              <Button
                variant="contained"
                color="primary"
                onClick={validarContaPagar}
              >
                <i
                  className="ph-fill ph-check-circle"
                  style={{ color: "white", fontSize: 22, marginRight: 10 }}
                ></i>
                Confirmar
              </Button>
              <Button
                variant="contained"
                style={{ marginLeft: 10 }}
                onClick={handleCloseDialog}
              >
                <i
                  className="ph-fill ph-x-circle"
                  style={{ color: "white", fontSize: 22, marginRight: 10 }}
                ></i>
                Cancelar
              </Button>
            </DialogActions>
          </Grid>
          <Loading loading={loading} />
        </DialogContent>
      </Dialog>
    </>
  );
};
export default DesdobrarTitulo;
